// eslint-disable-next-line no-unused-vars

function getConfigFile(env){
    var configLocation = (env.NODE_ENV == "production" ? "" : "public/");
    return require("../" + configLocation + "config.json"); //require('../public/config.json'); 
}


function invertColor(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}

var constants = {
    async setGlobalProps(app, env){
        var props = app.config.globalProperties;

        //var url = "http://172.16.62.131:5000/api/";
        //var url= "http://localhost:5000/api/";
        //var url = "https://itmpapi-beta.wilmar.co.id/api/";

        //var config = getConfigFile(env);
        //var url = config.connection;

        var url = env.VUE_APP_API_URL;

        props.$BAR_BG_COLOR = env.VUE_APP_BAR_BG_COLOR;
        props.$BAR_TEXT_COLOR = "#000000";//invertColor(props.$BAR_BG_COLOR, true);

        props.$maps_api_key = "AIzaSyAG8eYTbnMKa0OVXMSftKNlBA7af77vnjA";
        props.$OK = "OK"
        props.$FORM_MODE_VIEW = "View"
        props.$FORM_MODE_CREATE = "Create"
        props.$FORM_MODE_EDIT = "Edit"
        props.$FORM_MODE_DELETE = "Delete"
        props.$FORM_MODE_UNCHANGED = "Unchanged"
        props.$API_URL = url
        props.$AUTH_URL = url + "auth/menu" //env.VUE_APP_API_URL + "auth/menu"
        props.$UTIL_URL = url + "util/" //env.VUE_APP_API_URL + "util/"

        props.$TRANSPORTER_MASTER_TYPE={
            MASTER:"MasterData",
            INDEX:"Index"
        }

        props.$SAP_ORDER_LANGSIR = {
            DALAM_PABRIK:"DALAM_PABRIK",
            ANTAR_PABRIK:"ANTAR_PABRIK"
        }

        props.$ORDER_TYPE_NAME = {
            IPB_IN: "IPB IN",
            IPB_OUT: "IPB OUT",
            STO_IN: "STO IN",
            STO_OUT: "STO OUT",
            TO_IN: "TO IN",
            TO_OUT: "TO OUT",
            SO_NO: "SO No",
            PO_NO: "PO No"
        }

        props.$ORDER_CREATE_TYPE = {
            MANUAL: "MANUAL",
            SYNC_SAP: "SYNC SAP",
            TRANSFER_ORDER: "TRANSFER ORDER"
        }

        props.$ORDER_TYPE ={
            IPB: "IPB",
            STO: "STO",
            SPO:"SPO",
            SO: "SO",
            PO: "PO",
            TO: "TO"
        }
         
        props.$ORDER_STATUS = {
            UNASSIGNED: "UNASSIGNED TRANSPORTER",
            OUTSTANDING: "OUTSTANDING",
            APPROVED: "APPROVED",
            REJECTED: "REJECTED",
            DISPATCHED: "ASSIGNED TO TRANSPORTER", //ASSIGN TO TRANSPORTER
            ASSIGNED: "ASSIGNED TO DRIVER",
            VERIFIED: "VERIFIED",
            IN_PROGRESS: "IN PROGRESS",
            COMPLETED: "COMPLETED",
            ACCEPTED: "ACCEPTED",
            WAITING_FOR_APPROVAL: "WAITING FOR APPROVAL",
            WAITING_FOR_ORDER_APPROVAL: "WAITING FOR ORDER APPROVAL",
            WAITING_FOR_DISPATCH_APPROVAL: "WAITING FOR ASSIGN TO TRANSPORTER APPROVAL",
            WAITING_FOR_APPOINTMENT_APPROVAL: "WAITING FOR APPOINTMENT APPROVAL",
            CANCELLED: "CANCELLED"
        }
    
        props.$SHIPMENT_STATUS = {
            ALL : "ALL",
            OUTSTANDING : "OUTSTANDING",
            NEW : "NEW",
            IN_PROGRESS : "IN PROGRESS",
            COMPLETED : "COMPLETED",
            WAITING_FOR_APPOINTMENT_APPROVAL: "WAITING FOR APPOINTMENT APPROVAL"
        }

        props.$LOOKUP_GROUP = {
            SHIPMENT_TYPE : "SHIPMENT_TYPE",
            DISTRIBUTION : "DISTRIBUTION",
            DOCUMENT_TYPE : "DOCUMENT_TYPE",
            TRANSPORTER_QUOTA_BY : "TRANSPORTER_QUOTA_BY",
            TRANSPORTER_QUOTA_PER : "TRANSPORTER_QUOTA_PER",
            RELATION_SETTING: "RELATION_SETTING",
            ASSIGN_TRANSPORTER_REASON:"ASSIGN_TRANSPORTER_REASON",
            SAP_SYNC_SETTING: "SAP_SYNC_SETTING",
            STO_TRANSFER_TYPE: "STO_TRANSFER_TYPE",
            CONDITION_CATEGORY: "CONDITION_CATEGORY",
            TRANSFER_ORDER_DEFAULT: "TRANSFER_ORDER_DEFAULT",
            LANGSIR_TYPE: "LANGSIR_TYPE",
            STO_FILTER_BY: "STO_FILTER_BY",
            IPB_FILTER_BY: "IPB_FILTER_BY",
            ZGRDAILY: "ZGRDAILY",
            STO_TRANSACTION_TYPE: "STO_TRANSACTION_TYPE",
            CCY: "CCY",
            STO_TYPE: "STO_TYPE",
            SPO_TYPE: "SPO_TYPE",
            SERVICE_TYPE: "SERVICE_TYPE",
            STO_TRANSACTION_TYPE: "STO_TRANSACTION_TYPE",
            CONTINUOUS: "CONTINUOUS",
            ZGRDAILY_DATA: "ZGRDAILY_DATA",
            KB: "KB",
            FACILITY: "FACILITY",
            UNLOCK_TRANSACTION: "UNLOCK_TRANSACTION",
            CHANGE_STOSPO_STATUS: "CHANGE_STOSPO_STATUS",
            FREIGHT_TRIP_TYPE: "FREIGHT_TRIP_TYPE"
        }
    
        props.$SHIPMENT_SUB_STATUS = {
            APPOINTMENT : "APPOINTMENT CREATED",
            REGISTRATION_IN : "REGISTRATION IN",
            REGISTRATION_OUT : "REGISTRATION OUT",
            WAREHOUSE_IN : "IN WAREHOUSE"
        }
    
        props.$SHIPMENT_TYPE = {
            INDIVIDUAL_TRUCK : "INDIVIDUAL_TRUCK",
            INDIVIDUAL_TRANSPORTER : "INDIVIDUAL_TRANSPORTER",
            COLLECTIVE : "COLLECTIVE",
            RELATION: "RELATION"
        }
    
        props.$SHIPMENT_TYPE_CATEGORY = {
            INDIVIDUAL : "INDIVIDUAL",
            COLLECTIVE : "COLLECTIVE",
            RELATION: "RELATION"
        }
    
        props.$WB_SHIPMENT_TYPE = {
            LOADING : "LOADING",
            DESTINATION : "DESTINATION",
        }
    
        props.$APPROVAL_STATUS = {
            NEW : "NEW",
            WAITING_FOR_APPROVAL : "WAITING FOR APPROVAL",
            APPROVED : "APPROVED",
            REJECTED : "REJECTED",
        }
    
        props.$ROLES = {
            USER: "USER",
            TRANSPORTER: "TRANSPORTER",
            DRIVER: "DRIVER",
            CUSTOMER: "CUSTOMER",
            VENDOR: "VENDOR"
        }

        props.$ASSIGN_MATRIX_TYPE = {
            HIGHER: "HIGHER",
            LOWER: "LOWER",
            EXCEED: "EXCEED",
            NOT_INCLUDE: "NOT_INCLUDE",
            DIFFERENT_OA: "DIFFERENT_OA",
            DIFFERENT_NOT: "DIFFERENT_NOT"
        }

        props.$TRANSACTION_TYPE = {
            ORDER: "ORDER",
            SHIPMENT: "SHIPMENT",
            APPOINTMENT: "APPOINTMENT",
            STO: "STO",
            SPO: "SPO",
            SPO_ADJUSTMENT: "SPO ADJUSTMENT",
            IPB: "IPB"
        }
    
        props.$DEPARTMENTS = {
            WAREHOUSE: "WAREHOUSE",
            LOGISTIC: "LOGISTIC"
        }

        props.$REPORT_BY = [
            {
                label: "Truck",
                value: "Truck"
            },
            {
                label: "DO Qty",
                value: "DO Qty"
            },
        ]

        props.$SUMMARY_REPORT_BY = [
            {
                label: "Truck & DO Qty",
                value: "Truck & DO Qty"
            },
            {
                label: "Truck",
                value: "Truck"
            },
            {
                label: "DO Qty",
                value: "DO Qty"
            },
        ]

        props.$CHOOSE_UOM = [
            {
                label: "KG",
                value: "KG"
            },
            {
                label: "MT",
                value: "MT"
            },
            {
                label: "UOM Order",
                value: "UOM Order"
            },
        ]

        props.$SHOW_MERGED = [
            { 
                label: "Y", 
                value: "Y" 
            },
            { 
                label: "N",
                value: "N" 
            }
        ]

        props.$TRANSFER_TYPE = {
            IN:"IN",
            OUT:"OUT"
        }

        props.$STO_FILTER_BY = {
            PARTAI: "PARTAI",
            SHIPMENT: "SHIPMENT",
            WBREF: "WBREF"
        }

        props.$FILTER_BY = {
            SHIPMENT_COLLECTIVE: "SHIPMENT_COLLECTIVE" 
        }
        
        props.$ORDER_FILTER_BY = {
            IPB_IN: "IPB_IN",
            IPB_OUT: "IPB_OUT"
        }

        props.$CONDITION_CATEGORY = {
            FREIGHT: "FREIGHT",
            NON_FREIGHT: "NON FREIGHT"
        }

        props.$SERVICE_TYPE = {
            FREIGHT: "Freight Cost",
            FREIGHT_ADJUSTMENT: "Freight Cost Adjustment"
        }

        props.$STO_STATUS = {
            WAITING: "WAITING",
            SUCCESS: "SUCCESS",
            FAILED: "FAILED"
        }
    }
}

export default constants

